import { Fieldset, Grid, Space, TextInput } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';
import {
	IconBuildingBridge2,
	IconBuildingFortress,
	IconDialpad,
	IconFolderSymlink,
	IconLabel,
	IconMail,
	IconPhone,
	IconSitemap,
	IconWriting,
	IconZoomCode,
} from '@tabler/icons-react';
import { PhoneNumberInput } from '../../../components/PhoneNumberInput';
import { FormBranchMultiSelector } from '../../../components/form/FormBranchMultiSelector';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';

interface UpsertSupplierFormProps {
	form: UseFormReturnType<any, (values: any) => any>;
	selectedBranchIds?: string[];
}

export function UpsertSupplierForm({
	form,
	selectedBranchIds,
}: UpsertSupplierFormProps) {
	return (
		<>
			<Fieldset legend={'Information'}>
				<Grid>
					<Grid.Col span={6} pb={0}>
						<TextInput
							label={'Supplier Name'}
							placeholder="Insert supplier name..."
							key={form.key('name')}
							{...form.getInputProps('name')}
							leftSection={<IconWriting {...defaultIconStyle} />}
						/>
					</Grid.Col>
					<Grid.Col span={6} pb={0}>
						<TextInput
							label={'Supplier Reference'}
							placeholder="Insert supplier reference..."
							key={form.key('ref')}
							{...form.getInputProps('ref')}
							leftSection={<IconFolderSymlink {...defaultIconStyle} />}
						/>
					</Grid.Col>
					<Grid.Col span={12}>
						<FormBranchMultiSelector
							form={form}
							property={'branchIds'}
							preselectedBranchIds={selectedBranchIds}
						/>
					</Grid.Col>
				</Grid>
			</Fieldset>
			<Space h={20} />
			<Fieldset legend={'Contact & Address Details'}>
				<Grid>
					<Grid.Col span={12} pb={0}>
						<TextInput
							label="Address"
							placeholder="Insert address..."
							key={form.key('address')}
							{...form.getInputProps('address')}
							leftSection={<IconLabel {...defaultIconStyle} />}
						/>
					</Grid.Col>
					<Grid.Col span={4} pb={0}>
						<TextInput
							label={'Town'}
							placeholder="Insert town..."
							key={form.key('town')}
							{...form.getInputProps('town')}
							leftSection={<IconBuildingFortress {...defaultIconStyle} />}
						/>
					</Grid.Col>
					<Grid.Col span={4} pb={0}>
						<TextInput
							label={'Post Code'}
							placeholder="Insert post code..."
							key={form.key('postCode')}
							{...form.getInputProps('postCode')}
							leftSection={<IconZoomCode {...defaultIconStyle} />}
						/>
					</Grid.Col>
					<Grid.Col span={4} pb={0}>
						<TextInput
							label={'County'}
							placeholder="Insert county..."
							key={form.key('county')}
							{...form.getInputProps('county')}
							leftSection={<IconBuildingBridge2 {...defaultIconStyle} />}
						/>
					</Grid.Col>
					<Grid.Col span={6} pb={0}>
						<PhoneNumberInput
							label={'Phone Number'}
							key={form.key('phone')}
							{...form.getInputProps('phone')}
							leftSection={<IconPhone {...defaultIconStyle} />}
						/>
					</Grid.Col>
					<Grid.Col span={6} pb={0}>
						<TextInput
							label={'Email'}
							placeholder="Insert email..."
							key={form.key('email')}
							{...form.getInputProps('email')}
							leftSection={<IconMail {...defaultIconStyle} />}
						/>
					</Grid.Col>
					<Grid.Col span={6}>
						<TextInput
							label={'Website'}
							placeholder="Insert website..."
							key={form.key('website')}
							{...form.getInputProps('website')}
							leftSection={<IconSitemap {...defaultIconStyle} />}
						/>
					</Grid.Col>
					<Grid.Col span={6}>
						<TextInput
							label={'Account Number'}
							placeholder="Insert account number..."
							key={form.key('accountNo')}
							{...form.getInputProps('accountNo')}
							leftSection={<IconDialpad {...defaultIconStyle} />}
						/>
					</Grid.Col>
				</Grid>
			</Fieldset>
		</>
	);
}
